import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  className?: string
}

const BlockTitle = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('block-title-component', className)}>{children}</div>
}

export default BlockTitle
